<template>
  <div class="timeline container-fluid" :style="'background-image: url('+ require('@/assets/img/timeline.jpg') +')'">
    <div class="row h-100 align-items-center ">
      <ul class="timeline__lista col-12">
        <div class="row justify-content-center">
          <li class="timeline__lista__item" v-for="(item, index) in features" :key="index">
            <h3>{{item.value}}</h3>
            <p>{{item.title}}</p>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['features']
}
</script>
<style lang="scss">
@import '../assets/scss/_variables.scss';

.timeline{
  height: 22em;
  padding: 2em;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  @media (max-width: 1500px) {
    height: 15em;
  }
  @media (max-width: 800px) {
    height: auto;
  }
  @media (max-width: 1100px) {
    height: inherit;
  }
  @media (max-width: 575px) {
    padding: 20px 0;
  }
  &__lista{
    margin: 0px;
    &__item{
      padding: 3em;
      color: #fff;
      text-align: center;
      max-width: 20em;
      padding-top: 7em;
      @media (max-width: 1600px) {
        padding-top: 3em;
        padding: 1em;
      }
      @media (max-width: 575px) {
        padding: 0px;
        width: 100%;
      }
      h3{
        font-size: 40px;
        color: #bbbcbe;
        font-weight: 700;
        @media (max-width: 1500px) {
          font-size: 34px;
        }
        @media (max-width: 575px) {
          font-size: 24px;
          margin-bottom: 0px;
        }
      }
      p{
        font-weight: 600;
        font-style: italic;
        font-size: 23px;
        line-height: 35px;
        padding-top: 0.3em;
        @media (max-width: 1500px) {
          font-size: 18px;
        }
        @media (max-width: 575px) {
          font-size: 18px;
          padding-top: 0px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue